import { render, staticRenderFns } from "./WinnersTable.vue?vue&type=template&id=fc174608&scoped=true"
import script from "./WinnersTable.vue?vue&type=script&lang=js"
export * from "./WinnersTable.vue?vue&type=script&lang=js"
import style0 from "./WinnersTable.vue?vue&type=style&index=0&id=fc174608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc174608",
  null
  
)

export default component.exports